import {
  type ContractDataType,
  type MainPageContractTabs,
  type PaidSpecContractType,
  type SpecContractStatusType,
  type SpecContractType,
} from '../types/contract';

const specContractRequirenments: Record<
  SpecContractType | PaidSpecContractType,
  { level: number }
> = {
  Custom: {
    level: 6,
  },
  Golden: {
    level: 7,
  },
  GoldenPlus: {
    level: 7,
  },
  Grand: {
    level: 12,
  },
  GrandPlus: {
    level: 12,
  },
  Blitz: {
    level: 10,
  },
  BlitzPlus: {
    level: 10,
  },
};

const validateSpecContractVisibilityForTab = (
  kind: SpecContractType | PaidSpecContractType,
  status: SpecContractStatusType,
  tab: MainPageContractTabs,
): boolean => {
  if (tab === 'standart') {
    return status === 'inProgress' && kind !== 'Custom';
  } else {
    const allowedStatuses: SpecContractStatusType[] = [
      'done',
      'forViewing',
      'lock',
      'open',
      'wait',
    ];

    return (
      allowedStatuses.includes(status) ||
      (kind === 'Custom' && status === 'inProgress')
    );
  }
};

const getSpecContractModalToOpen = (
  kind: SpecContractType | PaidSpecContractType,
  status: SpecContractStatusType,
  contract: ContractDataType,
):
  | {
      renderKind: 'takeContract';
      props: { contractData: ContractDataType };
    }
  | {
      renderKind: 'grandContractModal';
      props: { status: SpecContractStatusType; kind: 'Grand' | 'GrandPlus' };
    }
  | {
      renderKind: 'blitzContractModal';
      props: { status: SpecContractStatusType; kind: 'Blitz' | 'BlitzPlus' };
    }
  | {
      renderKind: 'goldenContractModal';
      props: { status: SpecContractStatusType; kind: 'Golden' | 'GoldenPlus' };
    } => {
  switch (kind) {
    case 'Golden':
    case 'GoldenPlus': {
      return {
        renderKind: 'goldenContractModal',
        props: { status, kind },
      };
    }
    case 'Grand':
    case 'GrandPlus': {
      return {
        renderKind: 'grandContractModal',
        props: { status, kind },
      };
    }
    case 'Blitz':
    case 'BlitzPlus': {
      return {
        renderKind: 'blitzContractModal',
        props: { status, kind },
      };
    }
    default: {
      return {
        renderKind: 'takeContract',
        props: { contractData: contract },
      };
    }
  }
};

const mapSpecContract: Record<
  SpecContractType | PaidSpecContractType,
  SpecContractType
> = {
  Custom: 'Custom',
  Grand: 'Grand',
  GrandPlus: 'Grand',
  Golden: 'Golden',
  GoldenPlus: 'Golden',
  Blitz: 'Blitz',
  BlitzPlus: 'Blitz',
};

export {
  getSpecContractModalToOpen,
  mapSpecContract,
  specContractRequirenments,
  validateSpecContractVisibilityForTab,
};
